import { createAnalyticsGroup } from 'js/lib/analytics'

export const track = createAnalyticsGroup('Newsletter Subscribe')

;(function ($) {
  $.petrescue.init('.cards-common-subscribe-newsletter', function () {
    $('.cards-common-subscribe-newsletter .button').on('click', function (e) {
      //GA analytics
      const page = e.target.dataset.page
      track('subscribe', page)

      e.preventDefault()
      const $form = $(e.target).closest('.cards-common-subscribe-newsletter')
      const $emailInput = $form.find('input.email')
      const list_subscription = {
        email: $emailInput.val(),
      }

      const mc_segments = []
      const mc_tags = ['signed_up_via_subscribe_page']

      $emailInput.parent().removeClass('error')
      $('.cards-common-subscribe-newsletter__subscribe_confirm').empty()

      if ($('#animal_welfare_segment').length > 0) mc_segments.push('animal_welfare_strategy')
      if ($('.cards-common-subscribe-newsletter__petrescue_post').length > 0) mc_segments.push('petrescue_post')

      $.ajax({
        type: 'POST',
        url: '/list_subscriptions',
        dataType: 'json',
        data: {
          list_subscription,
          list_type: 'core',
          mc_segments,
          mc_tags
        },
        success: function () {
          const name = ($form.find('input.name').val() || '').trim()
          const successPath = name && name !== 'undefined' ? `/subscribe/success?name=${encodeURIComponent(name)}` : '/subscribe/success'

          window.location.replace(successPath)
        },
        error: function () {
          $emailInput.parent().addClass('error').focus()
        },
      })
    })
  })
})(jQuery)
